<template>
  <a-layout id="components-layout-demo-top-side-2">
    <Header />
    <a-layout-content class="container" id="content">
      <router-view></router-view>
    </a-layout-content>
  </a-layout>
</template>

<script>
import Header from "../header/Header.vue";
import { mapState } from "vuex";
export default {
  name: "layout",
  components: {
    Header,
  },
  computed: {
    ...mapState({
      loading: (state) => state.user.loading,
    }),
  },
  watch: {
    $route() {
      this.$store.commit("user/RESET_LOADING");
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize());
  },
  mounted() {
    this.handleResize();
  },
  methods: {
    handleResize() {
      const header = document.getElementById("header");
      const content = document.getElementById("content");
      if (header && content) {
        content.style.marginTop = `${header.clientHeight}px`;
      }
    },
  },
};
</script>
